module.exports = __webpack_public_path__ + "static/img/play_again.84c8784.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/win_lose/play_again.png
// module id = vlBo
// module chunks = 1